// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionText_sectionTitle__Vwn4V","sectionText":"SectionText_sectionText__DmrP8"};